import {
  BreakPointCondition,
  UI,
  useBreakpointIf,
  HStack,
  VStack,
  Stack,
} from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { OrdersConsolidatedQueryData } from '../../../../../store/orderHistory/selector';
import { getValidatedStatusIconAsSingleIconStatus } from '../../../../../utils/getValidatedStatusIcon';

export interface OrdersIndicatorsProps {
  isMobile: boolean;
  ordersConsolidated?: OrdersConsolidatedQueryData;
  orderConsolidatedLoading?: boolean;
  orderConsolidatedError?: Error;
}

export const OrdersIndicators: React.FC<OrdersIndicatorsProps> = ({
  isMobile,
  ordersConsolidated,
  orderConsolidatedLoading,
  orderConsolidatedError,
}) => {
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const showLoading = orderConsolidatedLoading || orderConsolidatedError || !ordersConsolidated;

  if (orderConsolidatedError) {
    return (
      <UI.Shadow level={1} p={Spacing['stack.xxxs']} borderRadius={'8px'}>
        <VStack space={Spacing['stack.nano']} alignItems="center">
          <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
            <UI.Icon
              name="Warning"
              testID="error-icon"
              color={Color['feedback.attention.default']}
              size="xs"
            />
            <UI.Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.lg']}>
              Ops, Algo deu errado!
            </UI.Text>
          </HStack>
          <UI.Text color="neutral.black">No momento não conseguimos te mostrar</UI.Text>
          <UI.Text color="neutral.black">
            os resultados. Tente novamente em alguns instantes
          </UI.Text>
        </VStack>
      </UI.Shadow>
    );
  }

  if (showLoading) {
    return (
      <HStack
        alignItems={'center'}
        space={Spacing['inline.xxxs']}
        justifyContent={'space-between'}
        {...(isMobile && { pb: Spacing['stack.nano'], mb: Spacing['stack.nano'] })}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box borderRadius={'8px'} key={index.toString()} flex={1}>
            <UI.Shadow level={1} p={Spacing['stack.xxxs']} borderRadius={'8px'}>
              <VStack space={Spacing['stack.xxxs']}>
                <UI.Text isLoading />
                <UI.Text isLoading />
              </VStack>
            </UI.Shadow>
          </Box>
        ))}
      </HStack>
    );
  }

  return (
    <HStack
      alignItems={'center'}
      space={Spacing['inline.xxxs']}
      justifyContent={'space-between'}
      {...(isTablet && { overflowX: 'scroll' })}
      {...(isMobile && { pb: Spacing['stack.nano'], mb: Spacing['stack.nano'] })}>
      {ordersConsolidated.map((item, index) => (
        <Stack key={index.toString()} minW="140px" flex={1} h="full">
          <UI.Indicator
            amount={item.total}
            iconStatus={getValidatedStatusIconAsSingleIconStatus(
              item.orderStatus.statusIcon,
              `indicator-icon-${index}`
            )}
            iconText={item.orderStatus.status || ''}
          />
        </Stack>
      ))}
    </HStack>
  );
};
